
function setrequestQuoteProducts(productform_content) {
    const contentEl = productform_content.querySelector('input.productcontent');

    const quoteproductData = {
        productId: contentEl.getAttribute('data-productid'),
        productHandle: contentEl.getAttribute('data-producthandle'),
        productbrand: contentEl.getAttribute('data-productbrand'),
        productreview: contentEl.getAttribute('data-productreview'),
        productTitle: contentEl.getAttribute('data-producttitle'),
        productImg: contentEl.getAttribute('data-productimg'),
        productPrice: contentEl.getAttribute('data-productprice'),
        productVariantId:productform_content.querySelector('input[name="id"]').value,
        productVariantLabel: contentEl.getAttribute('data-productvariantlabel'),
        productVarianttitle: contentEl.getAttribute('data-productvarianttitle'),
        productQty: productform_content.querySelector('input[name="quantity"]').value,
        productminQty: productform_content.querySelector('input[name="quantity"]').getAttribute('min'),
        productstepQty: productform_content.querySelector('input[name="quantity"]').getAttribute('step'),
        productUrl: contentEl.getAttribute('data-producturl'),
        productOptionname: Array.from(productform_content.querySelectorAll('.product-option-id'))
            .map(opt => opt.getAttribute('data-optionname'))
            .join(', ')
    };

    const quoteproductList = [quoteproductData];
    const quoteCurrProductPagevariantId = quoteproductData.productVariantId;
    const storedData = localStorage.getItem("quoteProduct");

    if (!storedData) {
        localStorage.setItem("quoteProduct", JSON.stringify(quoteproductList));
    } else {
        const parsedData = JSON.parse(storedData);
        const existingIds = parsedData.map(p => p.productVariantId);
        if (!existingIds.includes(quoteCurrProductPagevariantId)) {
            parsedData.push(quoteproductData);
            localStorage.setItem("quoteProduct", JSON.stringify(parsedData));
        }
    }

    addquoteproduct();

    const quotePopup = document.querySelector('.quotepopup-section');
    const productWrapper = quotePopup?.querySelector('.quotepopup-product-wrapper');
    if (productWrapper) {
        document.querySelector('.quick-add-modal .quick-add-modal__toggle[aria-label="Close"]')?.click();
        quotePopup.classList.add('quoteopen');
        quotePopup.style.display = 'flex';
        document.body.classList.add('small-quotepopup-open');
    }
}

function setrequestQuoteOptionProducts(productform_content) {
    const contentEl = productform_content.querySelector('input.productcontent');
    const optionInputs = productform_content.querySelectorAll('input.product-option-id');

    optionInputs.forEach(option => {
        const quoteproductData = {
            productId: option.getAttribute('data-optionid'),
            productHandle: option.getAttribute('data-optionhandle'),
            productbrand: contentEl.getAttribute('data-productbrand'),
            productreview: contentEl.getAttribute('data-productreview'),
            productTitle: option.getAttribute('data-optionname'),
            productImg: option.getAttribute('data-optionimg'),
            productPrice: option.getAttribute('data-optionprice'),
            productVariantId:productform_content.querySelector('input[name="id"]').value,
            productVariantLabel: contentEl.getAttribute('data-productvariantlabel'),
            productVarianttitle: contentEl.getAttribute('data-productvarianttitle'),
            productQty: productform_content.querySelector('input[name="quantity"]').value,
            productminQty: productform_content.querySelector('input[name="quantity"]').getAttribute('min'),
            productstepQty: productform_content.querySelector('input[name="quantity"]').getAttribute('step'),
            productUrl: option.getAttribute('data-optionurl'),
            productOptionname: `Main_product: ${option.getAttribute('data-mainproductname')}`
        };

        const quoteproductList = [quoteproductData];
        const quoteCurrProductPagevariantId = quoteproductData.productVariantId;
        const storedData = localStorage.getItem("quoteProduct");

        if (!storedData) {
            localStorage.setItem("quoteProduct", JSON.stringify(quoteproductList));
        } else {
            const parsedData = JSON.parse(storedData);
            const existingIds = parsedData.map(p => p.productVariantId);
            if (parsedData.length < 10 && !existingIds.includes(quoteCurrProductPagevariantId)) {
                parsedData.push(quoteproductData);
                localStorage.setItem("quoteProduct", JSON.stringify(parsedData));
            }
        }

        addquoteproduct();
    });
}


function addquoteproduct() {
    let productsPopup_section = document.querySelector('.quotepopup-section');
    const quoteProducts = localStorage.getItem('quoteProduct');
    const productsArray = quoteProducts ? JSON.parse(quoteProducts) : [];
    let popupContent = '';
    productsArray.forEach(function (product) {
        let productVariantLabel_avail = product.productVariantLabel;
        if (productVariantLabel_avail || productVariantLabel_avail != '' || productVariantLabel_avail != undefined) {
            productVariantLabel_avail = productVariantLabel_avail + ' : ';
        } else {
            productVariantLabel_avail = '';
        }

        let product_price = product.productPrice || "0";
        product_price = product_price.replace("$", "");
        let finaloptional_textval = ``;
        if (product.productOptionname != undefined) {
            if (product.productOptionname != '' && !product.productOptionname.includes('Main_product')) {
                const product_property = `Optional :` + product.productOptionname;
                const text = product_property.trim();
                const parts = text.split('Optional :');

                if (parts.length > 1 && parts != '') {
                    let options = parts[1].split(',');
                    finaloptional_textval = '<span>Optional : </span><ul>';
                    for (var i = 0; i < options.length; i++) {
                        finaloptional_textval += '<li>' + options[i].trim() + '</li>';
                    }
                    finaloptional_textval += '</ul>';
                }
            } else {
                finaloptional_textval = ``;
            }
        } else {
            finaloptional_textval = ``;
        }


        popupContent += `
        <div class="quotepopup-product-item">
            <div class="quotepopup-product-img">
                <a href="${product.productUrl}" class="quotepopup-product-imglink">
                    <img src="${product.productImg}" alt="Quote popup product image"/>
                </a>
            </div>
            <div class="quotepopup-product-content">
                <div class="flex gap-10 justify-between">
                    <span class="font-weight-600 h6 block__brand-item">${product.productbrand}</span>
                    ${product.productreview > 0
                        ? ` <div class="flex gap-5 justify-between items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
                                    <path d="M7.80979 0.585409C7.86966 0.401147 8.13034 0.401148 8.19021 0.58541L9.75121 5.38967C9.77798 5.47207 9.85478 5.52786 9.94142 5.52786H14.9929C15.1867 5.52786 15.2672 5.77579 15.1105 5.88967L11.0237 8.85886C10.9536 8.90979 10.9243 9.00006 10.9511 9.08247L12.5121 13.8867C12.5719 14.071 12.361 14.2242 12.2043 14.1103L8.11756 11.1411C8.04746 11.0902 7.95254 11.0902 7.88244 11.1411L3.7957 14.1103C3.63895 14.2242 3.42806 14.071 3.48793 13.8867L5.04893 9.08247C5.0757 9.00006 5.04637 8.90979 4.97627 8.85886L0.889527 5.88967C0.732784 5.77579 0.81334 5.52786 1.00708 5.52786H6.05858C6.14523 5.52786 6.22202 5.47207 6.24879 5.38967L7.80979 0.585409Z" fill="#EDDB00"/>
                                </svg>
                                <span class="desktop_mobile_small">${product.productreview}</span>
                            </div>`
                        : ``
                    }
                </div>
                <div class="quotepopup-product-titlecontent">
                    <a href="${product.productUrl}" class="quotepopup-product-title extra_body font-weight-500" data-producthandle="${product.productHandle}">${product.productTitle}</a>
                </div>
                <div class="quotepopup-product-variantcontent none">
                    <div class="quotepopup-product-varianttxt">
                        ${ product.productVarianttitle != ''
                        ? `<span class="quotepopup-product-varianttitle font-weight-500 body">${productVariantLabel_avail}</span>
                        <span class="quotepopup-product-variantval font-weight-500 body">${product.productVarianttitle}</span>`
                        : ''
                        }
                        <input type="hidden" name="variantId[]" value="${product.productVariantId}"/>
                        <span class="quotepopup-product-price hide hidden visually-hidden">${product_price}</span>
                    </div>
                    <div class="quotepopup-product-propertywrap small_body">
                        <span class="quotepopup-product-propertytxt">${finaloptional_textval}</span>
                    </div>
                </div>
                <div class="flex gap-5 justify-between items-center block__item-wrapper-qtyremoveprice">
                    <div class="quotepopup-product-qtyremove-content flex gap-5 justify-between items-center w-full">
                        <div class="quotepopup-product-qtycontent">
                            <quantity-input class="quantity cart-quantity" data-url="${product.productUrl}" data-section="template--${product.productId}__main">
                                <button class="quantity__button" name="minus" type="button">
                                    <span class="svg-wrapper">
                                    <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 1L11 1" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                                    </svg>
                                    </span>
                                </button>
                                <input class="quantity__input font-weight-400" type="number" data-productqtyid="${product.productVariantId}" name="updates[]" 
                                    value="${product.productQty}" min="${product.productminQty}" data-min="${product.productminQty}" step="${product.productstepQty}" 
                                    id="Quantity-template--${product.productId}__main" form="product-form-template--${product.productTitle}__main"
                                >
                                <button class="quantity__button" name="plus" type="button">
                                    <span class="svg-wrapper">
                                    <svg width="12" height="12" class="icon icon-plus" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M6 1V11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                                        <path d="M1 6L11 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                                    </svg>
                                    </span>
                                </button>
                            </quantity-input>
                        </div>
                        <input type="hidden" name="quantity[]" value="${product.productQty}">
                        <input type="hidden" name="p_title[]" value="${product.productTitle}">
                        <input type="hidden" name="p_price[]" value="${product_price}">
                        <div class="quotepopup-product-removecontent">
                            <a href="javascript:void(0);" class="quotepopup-product-removelink flex gap-5 justify-between items-center font-weight-600 medium_body text-capitalize" data-productid="${product.productId}" data-productremoveid="${product.productVariantId}">
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M15.8359 5.83325C15.6149 5.83325 15.403 5.92105 15.2467 6.07733C15.0904 6.23361 15.0026 6.44557 15.0026 6.66659V15.9924C14.9787 16.4138 14.7892 16.8087 14.4755 17.0911C14.1618 17.3734 13.7492 17.5204 13.3276 17.4999H6.6776C6.25602 17.5204 5.84342 17.3734 5.52969 17.0911C5.21596 16.8087 5.02651 16.4138 5.0026 15.9924V6.66659C5.0026 6.44557 4.91481 6.23361 4.75853 6.07733C4.60225 5.92105 4.39028 5.83325 4.16927 5.83325C3.94826 5.83325 3.7363 5.92105 3.58002 6.07733C3.42374 6.23361 3.33594 6.44557 3.33594 6.66659V15.9924C3.35972 16.8559 3.72476 17.6748 4.35109 18.2698C4.97742 18.8647 5.814 19.1872 6.6776 19.1666H13.3276C14.1912 19.1872 15.0278 18.8647 15.6541 18.2698C16.2805 17.6748 16.6455 16.8559 16.6693 15.9924V6.66659C16.6693 6.44557 16.5815 6.23361 16.4252 6.07733C16.2689 5.92105 16.057 5.83325 15.8359 5.83325Z" fill="#012B67"/>
                                    <path d="M16.6667 3.33325H13.3333V1.66659C13.3333 1.44557 13.2455 1.23361 13.0893 1.07733C12.933 0.921049 12.721 0.833252 12.5 0.833252H7.5C7.27899 0.833252 7.06702 0.921049 6.91074 1.07733C6.75446 1.23361 6.66667 1.44557 6.66667 1.66659V3.33325H3.33333C3.11232 3.33325 2.90036 3.42105 2.74408 3.57733C2.5878 3.73361 2.5 3.94557 2.5 4.16659C2.5 4.3876 2.5878 4.59956 2.74408 4.75584C2.90036 4.91212 3.11232 4.99992 3.33333 4.99992H16.6667C16.8877 4.99992 17.0996 4.91212 17.2559 4.75584C17.4122 4.59956 17.5 4.3876 17.5 4.16659C17.5 3.94557 17.4122 3.73361 17.2559 3.57733C17.0996 3.42105 16.8877 3.33325 16.6667 3.33325ZM8.33333 3.33325V2.49992H11.6667V3.33325H8.33333Z" fill="#012B67"/>
                                    <path d="M9.16667 14.1667V8.33333C9.16667 8.11232 9.07887 7.90036 8.92259 7.74408C8.76631 7.5878 8.55435 7.5 8.33333 7.5C8.11232 7.5 7.90036 7.5878 7.74408 7.74408C7.5878 7.90036 7.5 8.11232 7.5 8.33333V14.1667C7.5 14.3877 7.5878 14.5996 7.74408 14.7559C7.90036 14.9122 8.11232 15 8.33333 15C8.55435 15 8.76631 14.9122 8.92259 14.7559C9.07887 14.5996 9.16667 14.3877 9.16667 14.1667Z" fill="#012B67"/>
                                    <path d="M12.5026 14.1667V8.33333C12.5026 8.11232 12.4148 7.90036 12.2585 7.74408C12.1022 7.5878 11.8903 7.5 11.6693 7.5C11.4483 7.5 11.2363 7.5878 11.08 7.74408C10.9237 7.90036 10.8359 8.11232 10.8359 8.33333V14.1667C10.8359 14.3877 10.9237 14.5996 11.08 14.7559C11.2363 14.9122 11.4483 15 11.6693 15C11.8903 15 12.1022 14.9122 12.2585 14.7559C12.4148 14.5996 12.5026 14.3877 12.5026 14.1667Z" fill="#012B67"/>
                                </svg>
                                <span class="quotepopup-product-removetxtheading-family">Delete</span>
                            </a>
                        </div>
                    </div>
                   <div class="quotepopup-product-price quoteprice-${product_price} extra_body font-weight-600">${product.productPrice}</div>
                    <div class="quotepopup-product-removecontent">
                        <a href="javascript:void(0);" class="quotepopup-product-removelink desktop_mobile_small font-weight-600 text-capitalize" data-productid="${product.productId}" data-productremoveid="${product.productVariantId}">
                            <span class="quotepopup-product-removetxt">Remove</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        `;
    });
    if (popupContent != '') {
        popupContent += `<div class="quotepopup-product-item  quotepopup-product-moreitem">
            <a href="javascript:void(0);" class="quotepopup-moreproduct"> 
                <span class="quotepopup-moreproduct-icon">
                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.1999 7.69998H8.80002V1.29995C8.80002 0.858446 8.44158 0.5 7.99993 0.5C7.55842 0.5 7.19998 0.858446 7.19998 1.29995V7.69998H0.799949C0.358446 7.69998 0 8.05842 0 8.49993C0 8.94158 0.358446 9.30002 0.799949 9.30002H7.19998V15.6999C7.19998 16.1416 7.55842 16.5 7.99993 16.5C8.44158 16.5 8.80002 16.1416 8.80002 15.6999V9.30002H15.1999C15.6416 9.30002 16 8.94158 16 8.49993C16 8.05842 15.6416 7.69998 15.1999 7.69998Z" fill="#000000"/>
                </svg>                                   
                </span>
            </a>
        </div>`;
    } else { }
    
    const productdrawerWrapper = document.querySelector('.quotedrawer-product-submitbtn')
    if (productdrawerWrapper && !document.querySelector('.quotepopup-product-notewrap')) {
    productdrawerWrapper.insertAdjacentHTML('beforebegin', `
        <div class="quotepopup-product-notewrap line-height">
            <div class="quotepopup-note">
                <textarea name="customerNotes" class="form-control quotepopup-product-note w-full primary-border-radius" maxlength="1000" required  placeholder="Note"></textarea>
            </div>
        </div>
    `);
    }
    if (productsPopup_section.querySelector('.quotepopup-product-wrapper')) {
        productsPopup_section.querySelector('.quotepopup-product-wrapper').innerHTML = popupContent;
        //productsPopup.style.display = 'block';
    } else { }
    const productWrapper = productsPopup_section.querySelector('.quotepopup-product-wrapper');
    if (productWrapper) {
        productWrapper.innerHTML = popupContent;

        // Now add note wrapper AFTER productWrapper if not already present
        let noteWrap = productsPopup_section.querySelector('.quotepopup-product-notewrap');
        if (!noteWrap) {
            noteWrap = document.createElement('div');
            noteWrap.className = 'quotepopup-product-notewrap';
            noteWrap.innerHTML = `<div class="quotepopup-note"><textarea name="customerNotes" class="form-control quotepopup-product-note" placeholder="Add Note"></textarea></div>`;
            productWrapper.parentNode.insertBefore(noteWrap, productWrapper.nextSibling);
        }
    }

    document.querySelector('.quotepopup-countproduct').innerHTML = productsArray.length;
    if (productsArray.length == 0) {
        document.querySelector('.quotepopup-headingwrap').classList.add('quotepopup-centerheading');
        document.querySelector('.quotepopup-heading-available').style.display = 'none';
        document.querySelector('.quotepopup-heading-empty').style.display = 'flex';
        document.querySelector('.quotepopup-wrapper .quotepopup-closebtn .icon-caret').style.display = 'none';
        document.querySelector('.quotepopup-section').classList.add('empty-quotesection');
        //document.querySelector('.quotepopup-innerwrapper').style.display = 'none';
    } else {
        document.querySelector('.quotepopup-headingwrap').classList.remove('quotepopup-centerheading');
        document.querySelector('.quotepopup-heading-empty').style.display = 'none';
        document.querySelector('.quotepopup-heading-available').style.display = 'flex';
        document.querySelector('.quotepopup-wrapper .quotepopup-closebtn .icon-caret').style.display = 'block';
        document.querySelector('.quotepopup-section').classList.remove('empty-quotesection');
        //document.querySelector('.quotepopup-innerwrapper').style.display = 'flex';
    }

    var quotedrawer_productlist = document.querySelector('.quoteproduct-list-wrapper');
    if (quotedrawer_productlist) {
        quotedrawer_productlist.querySelector('.quotedrawer-product-wrapper').innerHTML = popupContent;
    } else { }


    // productsPopup_section.addEventListener('click', function(e) {
    //     if (e.target === productsPopup_section) {
    //         // productsPopup.style.display = 'none';
    //         document.querySelector('.quotepopup-closebtn').click();
    //     }
    // });

    // Remove item from localStorage
    document.querySelectorAll('.quotepopup-product-removecontent .quotepopup-product-removelink').forEach(link => {
        link.addEventListener('click', () => {
            const product_variantid = link.getAttribute('data-productremoveid');
            removeProductById(product_variantid);
            addquoteproduct();
            checkQuantities();
        });
    });
    //quantity update
    document.querySelectorAll('.quotepopup-product-qtycontent .quantity__button').forEach(function(button) {
        button.addEventListener('click', function() {
            
            const quantityContainer = button.closest('.quantity');
            const qtyInput = quantityContainer.querySelector('.quantity__input');
            const product_qty_update = qtyInput.value;
            const product_qty_id = qtyInput.getAttribute('data-productqtyid');

            const wrapper = button.closest('.quotepopup-product-qtyremove-content');
            const hiddenQtyInput = wrapper.querySelector('input[name="quantity[]"]');
            if (hiddenQtyInput) {
            hiddenQtyInput.value = product_qty_update;
            }
            updateProductQuantity(product_qty_id, product_qty_update);
            checkQuantities();
        });
    });
    // Close/minimize button click
    window.addEventListener('load', () => {
        const closeBtn = document.querySelector('.quotepopup-section .quotepopup-closebtn .icon-close');
        if (!closeBtn) return;
        closeBtn.addEventListener('click', closeQuotePopup);
    });

    function closeQuotePopup(event) {
        event.stopPropagation(); 

        const quoteProducts_storage = localStorage.getItem('quoteProduct');
        const quoteProducts_length = quoteProducts_storage ? JSON.parse(quoteProducts_storage).length : 0;

        const popupSection = document.querySelector('.quotepopup-section');
        if (!popupSection) return;

        if (quoteProducts_length === 0) {
            popupSection.classList.remove('quoteopen');
            popupSection.style.display = 'none';
            document.body.classList.remove('small-quotepopup-open');
        } else {
            popupSection.classList.remove('quoteopen');
            popupSection.style.display = 'flex';   
            document.body.classList.remove('small-quotepopup-open');
        }
    }

    // Minimize quote popup on wrapper click
    document.addEventListener('click', function (e) {
        const wrapper = e.target.closest('.quotepopup-section:not(.quoteopen) .quotepopup-wrapper');
        if (!wrapper) return;

        const popupSection = wrapper.closest('.quotepopup-section');
        if (popupSection && !popupSection.classList.contains('quoteopen')) {
            const quoteProducts_storage = localStorage.getItem('quoteProduct');
            const quoteProducts_length = quoteProducts_storage ? JSON.parse(quoteProducts_storage).length : 0;

            if (quoteProducts_length === 0) {
                popupSection.classList.remove('quoteopen');
                popupSection.style.display = 'none';
                document.body.classList.remove('small-quotepopup-open');
            } else {
                popupSection.classList.toggle('quoteopen');
                popupSection.style.display = 'flex';
                document.body.classList.toggle('small-quotepopup-open');
            }
        }
    });

}

//Drawer outside click
let quotedrawer_outside = document.querySelector('quote-drawer');
if (quotedrawer_outside) {
    quotedrawer_outside.addEventListener('click', function (e) {
        if (e.target === quotedrawer_outside) {
            // productsPopup.style.display = 'none';
            document.querySelector('.quotedrawer__close').click();
        }
    });
}


//Remove function
function removeProductById(productIdToRemove) {
    let storedProducts = localStorage.getItem('quoteProduct');
    let productArray = storedProducts ? JSON.parse(storedProducts) : [];

    let updatedProductArray = productArray.filter(function (product) {
        return product.productVariantId !== productIdToRemove;
    });

    localStorage.setItem('quoteProduct', JSON.stringify(updatedProductArray));
}
//Quantity function
function updateProductQuantity(productVariantId, newQuantity) {
    let storedProducts = localStorage.getItem('quoteProduct');
    let productArray = storedProducts ? JSON.parse(storedProducts) : [];
    let productIndex = productArray.findIndex(function(product) {
      return product.productVariantId === productVariantId;
    });
  
    if (productIndex !== -1) {
      productArray[productIndex].productQty = newQuantity;
      localStorage.setItem('quoteProduct', JSON.stringify(productArray));
      checkQuantities();
    } else {
      console.error('Product with ID', productId, 'not found.');
    }
}

// Request quote product
addquoteproduct();

// JavaScript code
// Event delegation for '.product-requestquote-btn'
document.addEventListener('click', function (e) {
    if (e.target.closest('.product-requestquote-btn')) {
        e.preventDefault();
        const btn = e.target.closest('.product-requestquote-btn');
        const productform_content = btn.closest('.block__get-a-quote');
        setrequestQuoteProducts(productform_content);
        if (productform_content.querySelector('.product-option-id')) {
            setrequestQuoteOptionProducts(productform_content);
        }
        checkQuantities();
    }
});

// Trigger quote from availability text
document.addEventListener('click', function (e) {
    if (e.target.closest('.mainproduct-checkavailability-txt')) {
        const productForm = e.target.closest('.block__get-a-quote');
        if (productForm) {
            const quoteBtn = productForm.querySelector('.product-requestquote-btn');
            if (quoteBtn) quoteBtn.click();
        }
    }
});

// Wishlist quote button
document.addEventListener('click', function (e) {
    if (e.target.closest('.swym-product-quote-btn')) {
        const btn = e.target.closest('.swym-product-quote-btn');
        const productform_content = btn.closest('.swym-product-actionbtnwrap');
        setrequestQuoteProducts(productform_content);
    }
});

// Header quote button
document.querySelector('.header-wrapper .quote_btn')?.addEventListener('click', function () {
    const storedProducts = localStorage.getItem('quoteProduct');
    const retstoredProducts = JSON.parse(storedProducts || '[]');
    if (storedProducts && retstoredProducts.length > 0) {
        if (document.body.classList.contains('block_menu-open')) {
            document.querySelector('.menu-drawer-closebtn')?.click();
        }

        const drawer = document.querySelector('.requestquote-drawer');
        if (drawer) {
            drawer.classList.add('quotedrawer_active');
            document.body.classList.add('body_quotedrawer_active');
        }
    } else {
        window.location.href = '/account';
    }
});

// Popup submit button transition
document.querySelector('.quotepopup-section .get_quotepopup_btn')?.addEventListener('click', function (e) {
    e.stopPropagation();
    const productsPopup = document.querySelector('.quotepopup-section');
    if (productsPopup.querySelector('.quotepopup-product-wrapper')) {
        productsPopup.classList.remove('quoteopen');
        document.body.classList.remove('small-quotepopup-open');
    }

    const drawer = document.querySelector('.requestquote-drawer');
    if (drawer) {
        drawer.classList.add('quotedrawer_active');
        document.body.classList.add('body_quotedrawer_active');
    }
});

// Close quote drawer
document.querySelector('.quotedrawer__close')?.addEventListener('click', function () {
    const drawer = this.closest('.requestquote-drawer');
    drawer?.classList.remove('quotedrawer_active');
    document.body.classList.remove('body_quotedrawer_active');

    const storedProducts = localStorage.getItem('quoteProduct');
    const retstoredProducts = JSON.parse(storedProducts || '[]');

    if (!storedProducts || retstoredProducts.length === 0) {
        setTimeout(() => {
            document.querySelector('#quoteproduct-listform')?.classList.remove('quote-products-hide');
            document.querySelector('#quoteproduct-listform').style.display = 'flex';
            document.querySelector('.quotedrawer-product-mainheading').style.display = 'block';
            document.querySelector('.quotedrawer-product-submittedcontent').classList.remove('quote-submit-active');
            document.querySelector('.quotedrawer-product-submittedcontent').style.display = 'none';
            localStorage.removeItem('quoteProduct');
        }, 1000);
    }
});

// Guest account switch
document.querySelector('.quote_guestaccount_formlink')?.addEventListener('click', function (e) {
    e.preventDefault();
    document.querySelector('.requestquote-login-formwrap').style.display = 'none';
    document.querySelector('#quote-register').style.display = 'block';
});

document.querySelector('.quote_loginaccount_linktxt')?.addEventListener('click', function (e) {
    e.preventDefault();
    document.querySelector('#quote-register').style.display = 'none';
    document.querySelector('.requestquote-login-formwrap').style.display = 'block';
});

// Input validation
document.querySelectorAll('.requestquote-drawer .quotepopup-contact-field .quoteinput-info').forEach(input => {
    input.addEventListener('blur', () => {
        const value = input.value.trim();
        const error = input.nextElementSibling;
        if (!value) {
            error.textContent = 'This field is required';
            error.style.display = 'block';
        } else {
            error.textContent = '';
            error.style.display = 'none';
        }
    });

    input.addEventListener('input', () => {
        const error = input.nextElementSibling;
        error.textContent = '';
        error.style.display = 'none';
    });
});

// Submit form
document.querySelectorAll('.quotedrawer-product-submitbtn').forEach(button => {
  button.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    console.log('clickbtn');

    const btnTxt = this.querySelector('.quotedrawer-product-submitbtn-txt');
    const btnLoading = this.querySelector('.quotedrawer-product-submitbtn-loading');
    btnTxt.classList.add('hidden');
    btnLoading.classList.remove('hidden');

    const formElement = document.querySelector('#quoteproduct-listform');
    const formData = new FormData(formElement);
     const customeremail = formData.get('customerEmail') || ''; // assuming form includes this field
    const secret = 'lgien$223502erssgg11pp'; // same as in your PHP file
    const token = CryptoJS.HmacSHA256(customeremail, secret).toString();
    formData.append('token', token);
    console.log("formData",formData)
              for (let [key, value] of formData.entries()) {
                console.log(`${key}: ${value}`);
              }
              
    fetch('https://app.kiefer.com/lifeguard/graphql/draftorder-create.php', {
      method: 'POST',
      body: formData
    })
    .then(response => response.text())
    .then(text => {
      console.log('Raw Response:', text);

      let data;
      try {
        const jsonStart = text.lastIndexOf('{');
        const jsonString = text.substring(jsonStart);
        data = JSON.parse(jsonString);
      } catch (err) {
        console.error('Response is not valid JSON:', err);
        showErrorState();
        return;
      }

      console.log('Parsed JSON:', data);

      // UI updates
      document.getElementById('quoteproduct-listform').classList.add('quote-products-hide');
      document.getElementById('quoteproduct-listform').style.display = 'none';
      const submittedContent = document.querySelector('.quotedrawer-product-submittedcontent');
      submittedContent.classList.add('quote-submit-active');
      submittedContent.style.display = 'block';

      const stored = localStorage.getItem('quoteProduct');
      const productsArray = stored ? JSON.parse(stored) : [];

      let popupContent = '';
      productsArray.forEach(product => {
        let productVariantLabel_avail = product.productVariantLabel;
        if (productVariantLabel_avail || productVariantLabel_avail != '' || productVariantLabel_avail != undefined) {
            productVariantLabel_avail = productVariantLabel_avail + ' : ';
        } else {
            productVariantLabel_avail = '';
        }
        let product_price = product.productPrice || "0";
        product_price = product_price.replace("$", "");
       
        popupContent += `
        <div class="quotepopup-product-item">
            <div class="quotepopup-product-img">
                <a href="${product.productUrl}" class="quotepopup-product-imglink">
                    <img src="${product.productImg}" alt="Quote popup product image"/>
                </a>
            </div>
            <div class="quotepopup-product-content">
                <div class="flex gap-10 justify-between">
                    <span class="font-weight-600 h6 block__brand-item">${product.productbrand}</span>
                    ${product.productreview > 0
                        ? ` <div class="flex gap-5 justify-between items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
                                    <path d="M7.80979 0.585409C7.86966 0.401147 8.13034 0.401148 8.19021 0.58541L9.75121 5.38967C9.77798 5.47207 9.85478 5.52786 9.94142 5.52786H14.9929C15.1867 5.52786 15.2672 5.77579 15.1105 5.88967L11.0237 8.85886C10.9536 8.90979 10.9243 9.00006 10.9511 9.08247L12.5121 13.8867C12.5719 14.071 12.361 14.2242 12.2043 14.1103L8.11756 11.1411C8.04746 11.0902 7.95254 11.0902 7.88244 11.1411L3.7957 14.1103C3.63895 14.2242 3.42806 14.071 3.48793 13.8867L5.04893 9.08247C5.0757 9.00006 5.04637 8.90979 4.97627 8.85886L0.889527 5.88967C0.732784 5.77579 0.81334 5.52786 1.00708 5.52786H6.05858C6.14523 5.52786 6.22202 5.47207 6.24879 5.38967L7.80979 0.585409Z" fill="#EDDB00"/>
                                </svg>
                                <span class="desktop_mobile_small">${product.productreview}</span>
                            </div>`
                        : ``
                    }
                </div>
                <div class="quotepopup-product-titlecontent">
                    <a href="${product.productUrl}" class="quotepopup-product-title extra_body font-weight-500" data-producthandle="${product.productHandle}">${product.productTitle}</a>
                </div>
                <div class="quotepopup-product-variantcontent">
                    <div class="quotepopup-product-varianttxt">
                        ${ product.productVarianttitle != ''
                        ? `<span class="quotepopup-product-varianttitle font-weight-500 body">${productVariantLabel_avail}</span>
                        <span class="quotepopup-product-variantval font-weight-500 body">${product.productVarianttitle}</span>`
                        : ''
                        }
                        <input type="hidden" name="variantId[]" value="${product.productVariantId}"/>
                        <span class="quotepopup-product-price  visually-hidden">${product_price}</span>
                    </div>
                </div>
                <div class="quotepopup-product-price quoteprice-${product_price} extra_body font-weight-600">${product.productPrice}</div>
            </div>
        </div>
        `;
      });

      document.querySelector('.quotedrawer-productlist-submitted').innerHTML = popupContent;
      localStorage.removeItem('quoteProduct');
      btnTxt.classList.remove('hidden');
      btnLoading.classList.add('hidden');

      const updated = localStorage.getItem('quoteProduct');
      const updatedArray = updated ? JSON.parse(updated) : [];

      const headingWrap = document.querySelector('.quotepopup-headingwrap');
      const headingAvailable = document.querySelector('.quotepopup-heading-available');
      const headingEmpty = document.querySelector('.quotepopup-heading-empty');
      const section = document.querySelector('.quotepopup-section');

      if (updatedArray.length === 0) {
        headingWrap.classList.add('quotepopup-centerheading');
        headingAvailable.style.display = 'none';
        headingEmpty.style.display = 'flex';
        section.classList.add('empty-quotesection');
      } else {
        headingWrap.classList.remove('quotepopup-centerheading');
        headingEmpty.style.display = 'none';
        headingAvailable.style.display = 'flex';
        section.classList.remove('empty-quotesection');
      }
    })
    .catch(err => {
      console.error('Fetch error:', err);
      showErrorState();
    });
    function showErrorState() {
      btnTxt.classList.remove('hidden');
      btnLoading.classList.add('hidden');
      alert('There was an issue submitting your quote. Please try again or contact support.');
    }
  });
});

// Account login submit functionality
let urlParams = new URLSearchParams(window.location.search);
if (urlParams.has("showDrawer") && urlParams.get("showDrawer") === "true") {
    // Open the drawer/modal
    let productsquoteDrawer = document.querySelector('.requestquote-drawer');
    if (productsquoteDrawer) {
        productsquoteDrawer.classList.add('quotedrawer_active');
        document.body.classList.add('body_quotedrawer_active');
        let orignalurl = window.location.origin + window.location.pathname;
        history.pushState({}, '', `${orignalurl}`);
    } else { }
}
// Quote popup plus button
document.addEventListener('click', function (e) {
    if (e.target.closest('.quotepopup-moreproduct')) {
        e.preventDefault();
        let closeBtn = document.querySelector('.quotepopup-wrapper .quotepopup-closebtn');
        if (closeBtn) closeBtn.click();
        setTimeout(() => {
        const input = document.getElementById('Search-In-Modal');
        if (input) input.focus();
        }, 300);
        if (window.innerWidth > 989) {
            const searchInput = document.querySelector('.header__search .header__icon--search');
            if (searchInput) searchInput.click();
        }else{
            document.querySelector('details-modal.header__search details summary').click();
            document.querySelector('details-modal.header__search details input.search__input').click();
        }
    }
});

// Quote popup Submit Quote button - Enable/Disable based on quantity
function checkQuantities() {
    const storedProducts = localStorage.getItem('quoteProduct');
    const productsArray = storedProducts ? JSON.parse(storedProducts) : [];
    let totalQty = 0;

    productsArray.forEach(product => {
        totalQty += parseInt(product.productQty, 10) || 0;
    });

    const addToQuoteBtn = document.querySelector('.quotedrawer-product-submitbtn');
    const quotepopupmsg = document.querySelector('.quotepopup-msg');
    if (!addToQuoteBtn) return;

    const body = document.querySelector('main');
    let minQty = parseInt(body.dataset.setMinQuntity);
    
    if (totalQty >= minQty) {
        addToQuoteBtn.classList.remove('disabled');
        quotepopupmsg.classList.add('none');
        addToQuoteBtn.disabled = false;
    } else {
        addToQuoteBtn.classList.add('disabled');
        quotepopupmsg.classList.remove('none');
        addToQuoteBtn.disabled = true;
    }
}

document.addEventListener('input', function(e){
    if(e.target.classList.contains('quantity__input')){
        const qty = parseInt(e.target.value, 10) || 0;
        updateProductQuantity(e.target.dataset.productqtyid, qty);
        checkQuantities();
    }
});
// Run on page load
document.addEventListener('DOMContentLoaded', checkQuantities);

window.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('input[name="quantity"]').forEach((input) => {
    let qty = parseInt(input.value, 10) || parseInt(input.getAttribute("min"), 10) || 1;
    input.value = qty;
    let variantId = input.closest("[data-productid]")?.dataset.productId || input.dataset.variantId;
    if (variantId) {
      let storedProducts = JSON.parse(localStorage.getItem("quoteProduct")) || [];
      let index = storedProducts.findIndex(p => p.productVariantId === variantId);
      if (index > -1) {
        storedProducts[index].productQty = qty;
      } else {
        storedProducts.push({
          productVariantId: variantId,
          productQty: qty
        });
      }
      localStorage.setItem("quoteProduct", JSON.stringify(storedProducts));
    }
  });
  addquoteproduct();
});

